const topicItems = [
  { label: '狂飙热议', heat: '9.8万讨论', icon: 'ri-fire-line' },
  { label: '国产剧推荐', heat: '8.5万讨论', icon: 'ri-tv-line' },
  { label: '悬疑烧脑', heat: '7.2万讨论', icon: 'ri-brain-line' },
  { label: '古装仙侠', heat: '6.8万讨论', icon: 'ri-magic-line' },
  { label: '科幻巨制', heat: '5.9万讨论', icon: 'ri-rocket-line' },
  { label: '韩剧精选', heat: '5.3万讨论', icon: 'ri-heart-line' },
  { label: '高分电影', heat: '4.7万讨论', icon: 'ri-film-line' },
  { label: '动漫番剧', heat: '4.2万讨论', icon: 'ri-ghost-line' },
  { label: '短剧专区', heat: '3.8万讨论', icon: 'ri-flashlight-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              话题热议
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              全网最热影视话题，等你来讨论
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {topicItems.map((topic, idx) => (
              <div
                key={topic.label}
                className={`flex items-center gap-3 p-3 md:p-4 rounded-xl cursor-pointer transition-all hover:scale-[1.02] ${
                  idx < 3
                    ? 'bg-accent-50 border border-accent-200/60'
                    : 'bg-background-50 border border-background-200/50'
                }`}
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  idx < 3 ? 'bg-accent-100' : 'bg-background-100'
                }`}>
                  <i className={`${topic.icon} text-base ${
                    idx < 3 ? 'text-accent-600' : 'text-foreground-500'
                  }`}></i>
                </div>
                <div className="min-w-0 flex-1">
                  <p className={`text-sm font-semibold truncate ${
                    idx < 3 ? 'text-accent-800' : 'text-foreground-800'
                  }`}>
                    #{topic.label}
                  </p>
                  <div className="flex items-center gap-1 mt-0.5">
                    <i className={`ri-fire-line text-xs ${
                      idx < 3 ? 'text-accent-500' : 'text-foreground-400'
                    }`}></i>
                    <span className={`text-xs ${
                      idx < 3 ? 'text-accent-600' : 'text-foreground-500'
                    }`}>{topic.heat}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}